import { MathText } from './MathText';
import { renderContentHtml } from './contentHtml';
import { shouldRenderCaptionAsHtml } from './imageAltText';

// One caption renderer for every unit type and for the PDF export, so a caption
// cannot look different depending on which unit it hangs off.
//
// Captions are historically PLAIN TEXT, so they are only parsed as markup when
// they actually contain a tag. Otherwise `Ratio A<B` would render as `Ratio A`
// — the HTML parser treats `<B` as an unclosed tag and swallows the rest.
//
// Renders inline content only; the caller owns the wrapper element and its
// class, because a <figcaption>, a <p>, and a table's <caption> are all correct
// in different places.
export function CaptionText({ text }: { text: string }) {
  if (shouldRenderCaptionAsHtml(text)) {
    return <>{renderContentHtml(text)}</>;
  }

  return <MathText text={text} />;
}
